import React, { useEffect } from 'react';
import { Input } from 'reactstrap';

import { BillingType, isInvoiceBillingType } from '~constants/maps';

import Icon, { faCheck, faXmark } from '~components/icon';

interface ComponentProps {
  value: {
    is_external_provider?: boolean;
    external_reference?: string;
    billing_type?: BillingType;
  };
  canEdit: boolean;
  onChange?: (name: string, value: any) => void;
}

const ExternalProvider: React.FC<ComponentProps> = ({ value = {}, canEdit, onChange }) => {
  const { is_external_provider, external_reference, billing_type } = value;
  const isInvoiceType = isInvoiceBillingType(billing_type as BillingType);

  useEffect(() => {
    if (isInvoiceType && !is_external_provider) {
      onChange?.('is_external_provider', true);
    }
  }, [isInvoiceType, is_external_provider, onChange]);

  const handleToggle = (checked: boolean) => {
    onChange?.('is_external_provider', checked);
  };

  if (!canEdit) {
    let content: React.ReactNode;

    if (external_reference) {
      content = external_reference;
    } else if (is_external_provider) {
      content = <Icon icon={faCheck} color="green" />;
    } else {
      content = <Icon icon={faXmark} color="red" />;
    }

    return <span>{content}</span>;
  }

  return (
    <div className="external-provider-check">
      <Input
        name="checkbox"
        type="checkbox"
        className="ps-2"
        checked={!!(isInvoiceType || is_external_provider)}
        disabled={isInvoiceType}
        onChange={({ target }) => handleToggle(target.checked)}
      />
      {is_external_provider && (
        <Input
          name="input"
          type="text"
          className="ps-2"
          placeholder="auto if blank"
          value={external_reference || ''}
          onChange={({ target }) => onChange?.('external_reference', target.value)}
        />
      )}
    </div>
  );
};

export default ExternalProvider;
